import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-14" data-id="element-113" data-mp="2z2fhrdf1raoo">
      <div className="mx-auto w-full max-w-xl" data-id="element-114" data-mp="2z51xi0c3cwhz">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-115" data-mp="3mtukv8endw0z">
          Frequently Asked Questions
        </h2>

        <div className="mt-8 space-y-3" data-id="element-116" data-mp="3d2zxu1tkuseh">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-gold/20 bg-white" data-id="element-117" data-mp="3i0i9hzyzblq6" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-118" data-mp="edjbm6wv4ogr">
                  <span className="text-[15px] font-semibold leading-snug text-ink" data-id="element-119" data-mp="2agjjubxi6fud">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-120" data-mp="25p1gxibx656r" />
                </button>
                <AnimatePresence initial={false} data-id="element-121" data-mp="2teckt8okgfp4">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: 'easeOut'
              }} data-id="element-122" data-mp="2ofrnbh0p8a4d">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-ink-soft" data-id="element-123" data-mp="1jr75tnx6a16j">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCTA headline="No open questions left. Start today." data-id="element-124" data-mp="1xqglmmhgut9z" />
      </div>
    </section>;
}